module.exports = __webpack_public_path__ + "img/key.e041f236.svg";